import { render, staticRenderFns } from "./SidebarHeader.vue?vue&type=template&id=9fac9964&scoped=true"
import script from "./SidebarHeader.vue?vue&type=script&lang=js"
export * from "./SidebarHeader.vue?vue&type=script&lang=js"
import style0 from "./SidebarHeader.vue?vue&type=style&index=0&id=9fac9964&prod&lang=css"
import style1 from "./SidebarHeader.vue?vue&type=style&index=1&id=9fac9964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fac9964",
  null
  
)

export default component.exports